// [AUDIT-2026-10-20] One submission at a time.
//
// A double-click on "Save" sent the form twice: a student, teacher or parent
// was created twice (or the second request answered "already exists" right
// after the first had succeeded), and an edit's second request found the row
// already changed. `guard(handler)` wraps a submit handler so a second call
// while the first is in flight is dropped. The check reads a ref, not state:
// two clicks can land before React re-renders the disabled button.
//
//   const [saving, guard] = useSubmitGuard();
//   <form onSubmit={guard(handleSubmit)}> … <Button type="submit" disabled={saving}>
import { useCallback, useRef, useState } from 'react';

export default function useSubmitGuard() {
  const busyRef = useRef(false);
  const [busy, setBusy] = useState(false);

  const guard = useCallback((handler) => async (...args) => {
    const event = args[0];
    if (event && typeof event.preventDefault === 'function') event.preventDefault();
    if (busyRef.current) return undefined;
    busyRef.current = true;
    setBusy(true);
    try {
      return await handler(...args);
    } finally {
      busyRef.current = false;
      setBusy(false);
    }
  }, []);

  return [busy, guard];
}
